import React, {useImperativeHandle, useRef} from 'react'
import WizModal from '../../../components/modal/WizModal'
import Text from '../../../components/text/Text'
import WizButton from '../../../components/button/WizButton'
import {deleteThumbnail} from '../../../apis/user/removeThumbnail'

interface IProps {
    className?: string
    userId: string
    refetch: () => void
}

const RemoveThumbnailModal = ({className, userId, refetch}: IProps, ref: any) => {
    const modalRef = useRef<any>()

    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
        },
    }))

    return (
        <>
            <WizModal title={'Remove Thumbnail'} className={`${className}`} ref={modalRef}>
                <Text className={'text-body2 text-font02'}>정말 해당 유저의 썸네일을 초기화 시키시겠습니까? </Text>
                <div className={'flex space-x-[5px] mt-[30px]'}>
                    <WizButton
                        text={'Cancel'}
                        type={'cancel'}
                        className={'flex-1'}
                        onClick={() => {
                            modalRef.current.close()
                        }}
                    />
                    <WizButton
                        text={'Delete'}
                        type={'red'}
                        className={'flex-1'}
                        onClick={async () => {
                            await deleteThumbnail(userId)
                            refetch()
                            modalRef.current.close()
                        }}
                    />
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(RemoveThumbnailModal)
